// extracted by mini-css-extract-plugin
export default {"zoneTableHeader":"zoneTableComponent_zoneTableHeader__0l4zD","table":"zoneTableComponent_table__V1C0U","emptyZone":"zoneTableComponent_emptyZone__aeXpo"};